import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IFiles, IFilesArray, IPolicies, IProgramsArray, IStepTree, TError } from './types/StepTree-interface';
import { fetchCalculation, fetchCreateInsuranceContractProjects, fetchCreateInsuranceContracts, fetchPolicyTemplate, fetchTextInfo } from './action/fetch-step-tree';

const initialState: IStepTree = {
    KidAgree: false,
    PolicyholderAgreement: false,
    PolicyAgree: false,
    InsuranceRulesAgree: false,
    AcceptanceAgree: false,
    FinalPremium: 0,
    SelectedProgramsIds: [],
    PolicyTemplate: {
        isLoadingPolicyTemplate: false,
        PolicyTemplateDataBase64: '',
        errorsPolicyTemplate: [],
    },
    TextInfo: {
        isLoadingTextInfo: false,
        TextInfo: '',
        errorsTextInfo: [],
    },
    Programs: {
        isLoadingPrograms: false,
        errorPrograms: [],
        ProgramsArray: [],
        RequestID: ''
    },
    ProgramsIDs: [],
    SaveProject: {
        isLoadingSaveProject: false,
        errorSaveProjects: [],
        ID: '',
        PayLink: ''
    },
    Files: {
        isLoadingFiles: false,
        Files: [],
        errorFiles: [],
        Policies: []
    }
};


export const StepTreeSlice = createSlice({
    name: 'StepTreeSlice',
    initialState,
    reducers: {
        updateField: (state, action: PayloadAction<{ field: keyof IStepTree; value: IStepTree[keyof IStepTree] }>) => {
            const { field, value } = action.payload;
            state[field] = value as never;
        },
        resetForm: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchPolicyTemplate.pending, (state) => {
                state.PolicyTemplate.isLoadingPolicyTemplate = true;
            })
            .addCase(fetchPolicyTemplate.fulfilled, (state, action: PayloadAction<{ PolicyTemplateDataBase64: string }>) => {
                state.PolicyTemplate.PolicyTemplateDataBase64 = action.payload.PolicyTemplateDataBase64;
                state.PolicyTemplate.isLoadingPolicyTemplate = false;
                state.PolicyTemplate.errorsPolicyTemplate = [];
            })
            .addCase(fetchPolicyTemplate.rejected, (state, action) => {
                state.PolicyTemplate.PolicyTemplateDataBase64 = initialState.PolicyTemplate.PolicyTemplateDataBase64;
                state.PolicyTemplate.isLoadingPolicyTemplate = false;
                state.PolicyTemplate.errorsPolicyTemplate = action.payload as TError;
            })
            .addCase(fetchTextInfo.pending, (state) => {
                state.TextInfo.isLoadingTextInfo = true;
            })
            .addCase(fetchTextInfo.fulfilled, (state, action: PayloadAction<{ Text: string }>) => {
                state.TextInfo.TextInfo = action.payload.Text;
                state.TextInfo.isLoadingTextInfo = false;
                state.TextInfo.errorsTextInfo = [];
            })
            .addCase(fetchTextInfo.rejected, (state, action) => {
                state.TextInfo.TextInfo = initialState.TextInfo.TextInfo;
                state.TextInfo.isLoadingTextInfo = false;
                state.TextInfo.errorsTextInfo = action.payload as TError;
            })
            .addCase(fetchCalculation.pending, (state) => {
                state.Programs.isLoadingPrograms = true;
            })
            .addCase(fetchCalculation.fulfilled, (state, action: PayloadAction<{ Programs: IProgramsArray[], RequestID: string }>) => {
                state.Programs.ProgramsArray = action.payload.Programs;
                state.Programs.RequestID = action.payload.RequestID;
                state.Programs.isLoadingPrograms = false;
                state.Programs.errorPrograms = [];
            })
            .addCase(fetchCalculation.rejected, (state, action) => {
                state.Programs.ProgramsArray = initialState.Programs.ProgramsArray;
                state.Programs.RequestID = initialState.Programs.RequestID;
                state.Programs.isLoadingPrograms = false;
                state.Programs.errorPrograms = action.payload as TError;
            })
             .addCase(fetchCreateInsuranceContractProjects.pending, (state) => {
                state.SaveProject.isLoadingSaveProject = true;
            })
            .addCase(fetchCreateInsuranceContractProjects.fulfilled, (state, action: PayloadAction<{  InvoiceID: string, InvoicePayLink: string }>) => {
                state.SaveProject.PayLink = action.payload.InvoicePayLink;
                state.SaveProject.ID = action.payload.InvoiceID;
                state.SaveProject.isLoadingSaveProject = false;
                state.SaveProject.errorSaveProjects = [];
            })
            .addCase(fetchCreateInsuranceContractProjects.rejected, (state, action) => {
                state.SaveProject.PayLink = initialState.SaveProject.PayLink;
                state.SaveProject.ID = initialState.SaveProject.ID;
                state.SaveProject.isLoadingSaveProject = false;
                state.SaveProject.errorSaveProjects = action.payload as TError;
            })
            
            .addCase(fetchCreateInsuranceContracts.pending, (state) => {
                state.Files.isLoadingFiles = true;
            })
            .addCase(fetchCreateInsuranceContracts.fulfilled, (state, action: PayloadAction<{  Files: IFilesArray[], Policies: IPolicies[] }>) => {
                state.Files.Files = action.payload.Files;
                state.Files.Policies = action.payload.Policies;
                state.Files.isLoadingFiles = false;
                state.Files.errorFiles = [];
            })
            .addCase(fetchCreateInsuranceContracts.rejected, (state, action) => {
                state.Files.Files = initialState.Files.Files;
                state.Files.Policies = initialState.Files.Policies;
                state.Files.isLoadingFiles = false;
                state.Files.errorFiles = action.payload as TError;
            })


    },
});

export const { updateField } = StepTreeSlice.actions;
export default StepTreeSlice.reducer;


